import { CustomProductList } from '@catalog/const';
import { CustomPageType, CustomRoutes } from '@core/const';
import { CustomAuthGuard, CustomLogoutGuard } from '@core/feature';
import { GifteryGuard } from '@promo/feature';
import { DeprecatedSearchParamsGuard } from '@search/feature';
import { AuthGuard, PageType } from '@spartacus/core';
import { CmsPageGuard, LoginGuard } from '@spartacus/storefront';
import { LoyaltyAuthGuard } from '@user/feature';

export const routes: CustomRoutes = [
  {
    path: null,
    canActivate: [AuthGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'companiesList' },
  },
  {
    path: null,
    canActivate: [AuthGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'orderDocuments' },
  },
  {
    path: null,
    canActivate: [AuthGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'bonus' },
  },
  {
    path: null,
    canActivate: [AuthGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'personalManagers' },
  },
  {
    path: null,
    canActivate: [CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: 'assignManager',
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: 'articleDetail',
      customCmsRouteContext: { type: CustomPageType.ArticlePage },
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard, DeprecatedSearchParamsGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: 'search',
      pageLabel: 'search',
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard, DeprecatedSearchParamsGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: 'category',
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard, DeprecatedSearchParamsGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: CustomProductList.PromoProductList,
      customCmsRouteContext: { type: CustomPageType.CampaignPage },
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard, DeprecatedSearchParamsGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: CustomProductList.SeoProductList,
      customCmsRouteContext: { type: CustomPageType.TagPage },
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard, DeprecatedSearchParamsGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: CustomProductList.SaleProductList,
      customCmsRouteContext: { type: PageType.CATEGORY_PAGE },
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard, DeprecatedSearchParamsGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: {
      cxRoute: CustomProductList.BestOffersProductList,
      customCmsRouteContext: { type: PageType.CATEGORY_PAGE },
    },
  },
  {
    path: null,
    canActivate: [CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { pageLabel: 'add-company', cxRoute: 'addCompany' },
  },
  {
    path: null,
    canActivate: [CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'articleList', pageLabel: 'articleList' },
  },
  {
    path: null,
    canActivate: [CustomAuthGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { pageLabel: 'wishlist', cxRoute: 'wishlist' },
  },
  {
    path: null,
    canActivate: [GifteryGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'giftery' },
  },
  {
    path: null,
    canActivate: [CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'trackingPickup', pageLabel: 'pickup-tracking' },
  },
  {
    path: null,
    canActivate: [LoyaltyAuthGuard, CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'loginLoyalty' },
  },
  {
    path: null,
    canActivate: [LoginGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
    data: { cxRoute: 'login' },
  },
  {
    path: null,
    canActivate: [CustomLogoutGuard],
    data: { cxRoute: 'logout' },
  },
  // должен быть последним роутом в ветке роутов
  {
    path: '**',
    canActivate: [CmsPageGuard],
    loadComponent: () => import('../lazy-reexports/storefront-page-layout').then((m) => m.PageLayoutComponent),
  },
];
